var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tray',{attrs:{"isOpen":_vm.isChatTrayOpen,"full":true,"keepActive":true,"additionalClasses":"w-96 pb-10 overflow-y-hidden"},on:{"close":_vm.toggleChatTray}},[_c('div',{staticClass:"h-full",attrs:{"id":"chat-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }